export default {
  remote: 'simplify_hub_aac_landing_mfe',
  name: 'aac-landing',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: {
    'localhost': 'http://localhost:4335/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1100769639/simplify-aac-landing/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1100769639/simplify-aac-landing/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1100769639/simplify-aac-landing/v1/mf2/mf-manifest.json',
  },
};
